// Extract to hook to make it possible to mock in tests
export const useWindowLocation = () => {
  const { href } = window.location;
  const setHref = (ref: string) => (window.location.href = ref);
  return { href, setHref };
};
